import * as R from 'ramda'
import P from 'helpers/predicates'

const isNotNull = R.both(
  R.complement(R.isEmpty),
  P.isNotNil
)

const checkObject = (func) => R.compose(
  func,
  R.prop('validationObject')
)

const isValuesEmpty = R.compose(
  R.not,
  R.any(R.compose(
    R.any(R.isEmpty),
    R.values
  ))
)

const hasNoDuplicates = (object) => R.compose(
  R.propEq('length', object.length),
  R.uniqBy(R.prop('linkType')),
)(object)

const validations = [
  [checkObject(isValuesEmpty), 'All object values cannot be empty.'],
  [checkObject(hasNoDuplicates), 'Duplicate connector count.']
]

export default [
  [R.propSatisfies(isNotNull, 'connectorType'), 'Connector type cannot be empty.'],
  [R.propSatisfies(isNotNull, 'connectorLocation'), 'Connector location cannot be empty.'],
  [R.propSatisfies(isNotNull, 'connectorSource'), 'Connector source cannot be empty.'],
  [R.propSatisfies(isNotNull, 'connectorFeature'), 'Connector feature cannot be empty.'],
  [R.propSatisfies(isNotNull, 'linkType'), 'Link type cannot be empty.']
]

export {
  validations
}
